import styled from 'styled-components';
import {wrapLongText} from '../../../styles/wrapLongText';

interface Props {
	description: string | null;
	labels?: string[];
}

const Heading = styled.h3`
	margin: 0 0 12px;
	font: ${p => p.theme.ticketing.font.subheading1};
	letter-spacing: 0.15px;
	color: #0f172a;
`;
const Body = styled.p`
	white-space: pre-wrap;
	${wrapLongText}
	font: ${p => p.theme.ticketing.font.body2};
	color: #334155;
	margin: 0;
`;
const LabelRow = styled.div`
	margin-top: 12px;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
`;
const LabelChip = styled.span`
	display: inline-flex;
	align-items: center;
	border-radius: 6px;
	background: #f1f5f9;
	padding: 2px 10px;
	font: ${p => p.theme.ticketing.font.body3};
	font-weight: 500;
	color: #475569;
`;

export function TicketDescription({description, labels}: Props) {
	if (!description && (!labels || labels.length === 0)) return null;

	return (
		<section>
			<Heading>Description</Heading>
			{description && <Body>{description}</Body>}
			{labels && labels.length > 0 && (
				<LabelRow>
					{labels.map(label => (
						<LabelChip key={label}>{label}</LabelChip>
					))}
				</LabelRow>
			)}
		</section>
	);
}
